import { render, staticRenderFns } from "./DisplayStorage.vue?vue&type=template&id=cc44ecf6&scoped=true&"
import script from "./DisplayStorage.vue?vue&type=script&lang=js&"
export * from "./DisplayStorage.vue?vue&type=script&lang=js&"
import style0 from "./DisplayStorage.vue?vue&type=style&index=0&id=cc44ecf6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc44ecf6",
  null
  
)

export default component.exports